import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        const message = error?.message || '';
        // Auto-recover stale/missing lazy chunks once
        const isChunkError = message.includes('Loading chunk') ||
            message.includes('ChunkLoadError') ||
            message.includes("Unexpected token '<'");
        if (isChunkError) {
            const reloadKey = 'chunk-reload-attempted';
            const alreadyRetried = sessionStorage.getItem(reloadKey) === '1';
            if (!alreadyRetried) {
                sessionStorage.setItem(reloadKey, '1');
                window.location.reload();
                return;
            }
        }
        // Ignore translation-related errors
        if (message && (message.includes('removeChild') ||
            message.includes('Maximum call stack') ||
            message.includes('NotFoundError'))) {
            console.log('Translation error caught and ignored');
            this.setState({ hasError: false });
            return;
        }
        console.error('Error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { style: { padding: 20, textAlign: 'center' }, children: [_jsx("h2", { children: "Something went wrong" }), _jsx("p", { style: { color: '#666', marginBottom: 12 }, children: "\u062D\u0635\u0644 \u062A\u0639\u0627\u0631\u0636 \u0645\u0624\u0642\u062A \u0641\u064A \u0645\u0644\u0641\u0627\u062A \u0627\u0644\u0635\u0641\u062D\u0629. \u0627\u0636\u063A\u0637 \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u062D\u0645\u064A\u0644 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629." }), _jsx("button", { onClick: () => {
                            try {
                                sessionStorage.removeItem('chunk-reload-attempted');
                            }
                            catch (error) {
                                console.warn('Unable to clear chunk reload flag', error);
                            }
                            window.location.reload();
                        }, children: "Reload" })] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
